/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Antragteilweiseversendet2Inputs */

const de__field_antragteilweiseversendet2 = /** @type {(inputs: _Field_Antragteilweiseversendet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrag teilweise versendet`)
};

/**

* @param {_Field_Antragteilweiseversendet2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_antragteilweiseversendet2 = /** @type {((inputs?: _Field_Antragteilweiseversendet2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Antragteilweiseversendet2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_antragteilweiseversendet2(inputs)
});
export { _field_antragteilweiseversendet2 as "_field_antragTeilweiseVersendet" }